import React from 'react';

import RichText from '../Global/RichText';
import { getColor, getMultiChoice } from '../Global/DataUtils/index';
import { BuildLinkHref } from '../Global/BuildLinkHref';

import * as styles from './multi-alert-banner.module.css';
import { CTALocation, KontentStringValue } from '../../../types/KontentProps';

interface Props {
    alerts: any[];
    targetLink?: CTALocation;
    windowAction?: {
        value: {
            codename: 'same_window' | 'new_window';
        }[];
    };
    anchor?: KontentStringValue;
}

const ScrollableBanner: React.FC<Props> = ({
    targetLink,
    alerts,
    windowAction,
    anchor,
}) => {
    const ctaLocationUrl =
        targetLink?.value?.[0]?.elements?.slug?.url ||
        targetLink?.value?.[0]?.elements?.third_party_url?.value ||
        targetLink?.value?.[0]?.elements?.document?.value?.[0]?.url ||
        targetLink?.value?.[0]?.elements?.file?.value?.[0]?.url;

    const ctaWindowAction = getMultiChoice(windowAction) || undefined;
    const ctaTarget = ctaWindowAction === 'new_window' ? '_new' : '_self';
    const linkHref = ctaLocationUrl ? BuildLinkHref(targetLink, anchor) : null;

    const barColor = getColor(alerts?.[0]?.elements?.bar_color) || '#f06623';
    const fontColor = getColor(alerts?.[0]?.elements?.font_color) || '#ffffff';

    const alertLabels = alerts?.map((alert) => alert.elements.message);

    const repeatedLabels = [];
    for (let i = 0; i < 30; i++) {
        repeatedLabels.push(alertLabels[i % alertLabels.length]);
    }
    const TrackWrapper = linkHref ? 'a' : 'div';

    return (
        <section
            className={styles.scrollBanner}
            style={{ backgroundColor: barColor, color: fontColor }}
        >
            <TrackWrapper
                href={linkHref || undefined}
                target={(linkHref && ctaTarget) || undefined}
                className={styles.trackWrapper}
            >
                <div className={styles.marqueeTrack}>
                    {repeatedLabels.map((label, index) => (
                        <React.Fragment key={index}>
                            {RichText(label)}
                        </React.Fragment>
                    ))}
                </div>
            </TrackWrapper>
        </section>
    );
};

export default ScrollableBanner;
